import { render, staticRenderFns } from "./rfq-view-sticky-header.vue?vue&type=template&id=84d1540c&scoped=true"
import script from "./rfq-view-sticky-header.vue?vue&type=script&lang=js"
export * from "./rfq-view-sticky-header.vue?vue&type=script&lang=js"
import style0 from "./rfq-view-sticky-header.vue?vue&type=style&index=0&id=84d1540c&prod&lang=css"
import style1 from "./rfq-view-sticky-header.vue?vue&type=style&index=1&id=84d1540c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d1540c",
  null
  
)

export default component.exports